import { render, staticRenderFns } from "./screenDetails.vue?vue&type=template&id=358d9eee&scoped=true&"
import script from "./screenDetails.vue?vue&type=script&lang=js&"
export * from "./screenDetails.vue?vue&type=script&lang=js&"
import style0 from "./screenDetails.vue?vue&type=style&index=0&id=358d9eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358d9eee",
  null
  
)

export default component.exports